import React, { useState } from "react";
import Modal from "../../../components/common/Modal";
import TextArea from "../../../components/common/TextArea";
import Button from "../../../components/common/Button";

const UserRequestActionModal = ({ isOpen, closeModal, action, onSubmit }) => {
  const [adminMessage, setAdminMessage] = useState("");

  const handleSubmit = () => {
    if (action === "delete") {
      onSubmit(null);
    } else {
      onSubmit(adminMessage);
    }
    setAdminMessage("");
  };

  const handleClose = () => {
    setAdminMessage("");
    closeModal();
  };

  return (
    <Modal isOpen={isOpen} closeModal={handleClose} title={`Confirm ${action}`}>
      <div className="flex flex-col space-y-4">
        {action !== "delete" && (
          <TextArea
            label="Admin Message"
            value={adminMessage}
            onChange={(e) => setAdminMessage(e.target.value)}
            rows={4}
            placeholder="Enter your message for the customer..."
          />
        )}
        <div className="flex justify-end space-x-2">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UserRequestActionModal;
